import React from 'react';
import { string } from 'prop-types';
import clsx from 'clsx';

import { SvgPlusCircle } from 'components/SvgIcon';

/**
 * Displays a Add _blank_ component with css and svg pre setup for Edit User sections
 * @param {String (required)} title: String to display after Add text
 */
export const Add = ({ text }) => {
  return (
    <span
      className="m-user-edit-drawer-section__add"
      data-testid="PlatformAdminUI-UsersLink-Add-AddEntity"
    >
      <SvgPlusCircle viewBox="0 0 20 20" />
      <span className={clsx('Body', 'm-user-edit-drawer-section__add__text')}>
        Add {text}
      </span>
    </span>
  );
};

Add.propTypes = {
  text: string.isRequired,
};
